module.exports = __webpack_public_path__ + "static/media/bord.552d009f.png";